import { Dayjs } from 'dayjs';
import { useState } from 'react';

export type InitialDatePicker = {
  startDate: Dayjs;
  endDate: Dayjs;
};

const useDatePicker = (initial?: InitialDatePicker) => {
  const [startDate, setStartDate] = useState(initial?.startDate ?? null);
  const [endDate, setEndDate] = useState(initial?.endDate ?? null);

  return { startDate, setStartDate, endDate, setEndDate };
};

export default useDatePicker;
